import { Controller } from "@hotwired/stimulus";

// Shows a filter cell only while another filter in the same dropdown holds a given value.
// A hidden cell's inputs are disabled so its stale values never submit with the visible ones.
export default class UIFilterVisibility extends Controller {
  static targets = ["field"];

  connect() {
    this.update();
  }

  update() {
    this.fieldTargets.forEach((field) => {
      const input = this.element.querySelector(`[name="${field.dataset.watchParam}"]`);
      field.hidden = !input || input.value !== field.dataset.watchValue;
      field.querySelectorAll("input, select, textarea").forEach((control) => {
        control.disabled = field.hidden;
      });
    });
  }
}
